import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Link, Text } from '@siteground/styleguide';

export const formattedTags = {
  href: (...href: string[]) => href,
  a: (...children: any[]) => {
    const [href = '', text = ''] = children && children[0].flat();

    return (
      <Link href={href} target="_blank">
        {text}
      </Link>
    );
  },
  p: (text: string) => <p>{text}</p>,
  em: (text: string) => <em>{text}</em>,
  strong: (text: string) => <strong>{text}</strong>,
  b: (text: string) => (
    <Text tag="span" weight="bold">
      {text}
    </Text>
  ),
  br: <br />
};

type TranslateProps = {
  id: string;
  tagName?: any;
  [key: string]: any;
};

const Translate: React.FC<TranslateProps> = ({ id, tagName, ...values }) => {
  if (!id) {
    return null;
  }

  if (typeof id !== 'string') {
    return id;
  }

  return (
    <FormattedMessage
      tagName={tagName}
      id={id}
      defaultMessage={id}
      values={{
        ...formattedTags,
        ...values
      }}
    />
  );
};

Translate.displayName = 'Translate';

export default Translate;
